<div class="modal-header">
  <h4 class="modal-title">Cash Break Solver Results</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>
<ul ngbNav #nav="ngbNav" class="nav-tabs">
  <li
    [ngbNavItem]="i"
    *ngFor="let cashBreakSuggestion of _cashBreakSuggestions; index as i"
  >
    <a ngbNavLink> Solution {{ i + 1 }}</a>
    <ng-template ngbNavContent>
      <ngb-alert
        [dismissible]="false"
        id="banner-alert"
        class="mb-0 py-0 pl-2 pr-4 ml-1"
      >
        This is an experimental feature. Make sure to verify the presented
        solution before applying it.
      </ngb-alert>
      <div class="modal-body pt-0">
        <nf-table-layout
          tableTitle="Clearwater Transactions to Clear"
          isSectionTitle
          [hideSearch]="true"
          [hideClearAll]="true"
          [gridOptions]="cwGridOptions"
          [data]="cashBreakSuggestion.cwTranToClear"
        ></nf-table-layout>
        <nf-table-layout
          tableTitle="Clearwater Transactions to Unclear"
          isSectionTitle
          [hideSearch]="true"
          [hideClearAll]="true"
          [gridOptions]="cwGridOptions"
          [data]="cashBreakSuggestion.cwTranToUnclear"
        ></nf-table-layout>
        <nf-table-layout
          tableTitle="External Transactions to Process"
          isSectionTitle
          [hideSearch]="true"
          [hideClearAll]="true"
          [gridOptions]="exGridOptions"
          [data]="cashBreakSuggestion.extTranToClear"
        ></nf-table-layout>
        <em>
          <small
            >Please ensure correct reconciliation practice is followed when
            processing External Transactions</small
          >
        </em>
      </div>
      <div class="modal-footer">
        <button
          nf-button="primary"
          (click)="filterTransactions(cashBreakSuggestion)"
        >
          Filter For Transactions
        </button>
        <button
          nf-button="primary"
          (click)="submitSuggestions(cashBreakSuggestion)"
          [disabled]="!(cashBreakSuggestion.extTranToClear.length === 0)"
        >
          Submit Suggestion
        </button>
      </div>
    </ng-template>
  </li>
</ul>
<div [ngbNavOutlet]="nav" class="mt-2"></div>
